module.exports = __webpack_public_path__ + "static/logo-Wshadow-light-62ca9e6ade35ec6eed52c973b4555ebb.png";